import { message } from 'ant-design-vue'
import { h } from 'vue'
import MessageContent from './messageContent.vue'
import Success from './success.vue'
import Warning from './warning.vue'

// antdvue message鼠标悬停时，不会在时间到后自动消失，和ba沟通后确认保留该逻辑
const DURATION = 3

const ICON_STYLE = {
  style: 'flex-shrink: 0'
}

function success (text: string) {
  if (__isBrowser__) {
    message.success({
      content: h(MessageContent, {
        type: 'success',
        message: text
      }),
      duration: DURATION,
      icon: h(Success, {
        ...ICON_STYLE
      })
    })
    // setTimeout(() => {
    //   message.destroy()
    // }, DURATION)
  }
}

function warning (text: string) {
  if (__isBrowser__) {
    message.warning({
      content: h(MessageContent, {
        type: 'warning',
        message: text
      }),
      duration: DURATION,
      icon: h(Warning, {
        ...ICON_STYLE
      })
    })
    // setTimeout(() => {
    //   console.log('DO_DESTROY')
    //   message.destroy()
    // }, DURATION)
  }

}

export default {
  success,
  warning
}
